import { Timestamp } from 'firebase/firestore';
import { AccessLevels } from './common';

export interface CompanyGenerationQuotaItem {
  max?: number | null;
}

export interface CompanyGenerationQuota {
  shopify?: CompanyGenerationQuotaItem;
  customContent?: CompanyGenerationQuotaItem;
  brandResearch?: CompanyGenerationQuotaItem;
  brandKeywordAssignment?: CompanyGenerationQuotaItem;
}

export interface CompanyGenerationUsage {
  shopify?: number;
  customContent?: number;
  brandResearch?: number;
  brandKeywordAssignment?: number;
}

export interface CompanyAmazonContentSettings {
  titleMaxChars?: number;
  bulletPointCount?: number;
  descriptionMaxChars?: number;
}

export interface CompanyModel {
  id: string;
  name?: string;
  status?: string;
  modules?: {
    shopify?: boolean;
    customContent?: boolean;
    generation?: boolean;
    brandResearch?: boolean;
  };
  createdAt?: Timestamp;
  updatedAt?: Timestamp;
  createdBy?: string;
  updatedBy?: string;
  userIds?: string[];
  accessLevels?: AccessLevels;
  customProductCount?: number;
  customProductBrands?: string[];
  generationQuota?: CompanyGenerationQuota;
  generationUsage?: CompanyGenerationUsage;
  amazonContentSettings?: CompanyAmazonContentSettings;
}

export enum CompanyStatus {
  CREATED = 'created',
  HIDDEN = 'hidden',
  DELETE = 'delete',
}

export interface UserProfile {
  id: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  createdAt?: Timestamp;
  updatedAt?: Timestamp;
  createdBy?: string;
  updatedBy?: string;
}
